export const selectedNotesConstants = {
  SELECT: "SELECTED_NOTES_SELECT",
  DESELECT: "SELECTED_NOTES_DESELECT",
  CLEAR: "SELECTED_NOTES_CLEAR",
};



// WEBPACK FOOTER //
// ./src/_constants/selectedNotes.constants.js